module.exports = __webpack_public_path__ + "static/media/recruitment_devices.84e3b11c.jpg";